import { useLang } from "../../context/LanguageContext";

export const MaxFramework = () => {
  const { t } = useLang();
  return (
    <section id="framework" data-testid="framework-section" className="py-24 lg:py-32 bg-[#0B1F3A] text-white relative overflow-hidden">
      {/* faint grid */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.06] pointer-events-none" aria-hidden="true">
        <defs>
          <pattern id="dotgrid" width="32" height="32" patternUnits="userSpaceOnUse">
            <circle cx="1" cy="1" r="1" fill="#D4AF37" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dotgrid)" />
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline text-[#D4AF37]">{t.framework.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light leading-tight">
              {t.framework.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-white/70 text-base lg:text-lg leading-relaxed">{t.framework.sub}</p>
          </div>
        </div>

        {/* Step flow */}
        <div className="border border-white/15 bg-white/[0.02] p-6 lg:p-8 overflow-x-auto">
          <div className="flex items-center min-w-[760px]">
            {t.framework.steps.map((step, i) => {
              const isLast = i === t.framework.steps.length - 1;
              const accent = i >= 3;
              return (
                <div key={step} className="flex items-center flex-1">
                  <div className="flex flex-col items-center">
                    <div
                      className={`w-12 h-12 border ${accent ? "border-[#D4AF37]" : "border-white/40"} flex items-center justify-center bg-[#0B1F3A]`}
                    >
                      <span className={`font-mono text-[11px] tracking-widest ${accent ? "text-[#D4AF37]" : "text-white/70"}`}>
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <span className={`mt-3 text-xs font-semibold tracking-wider uppercase ${accent ? "text-[#D4AF37]" : "text-white"}`}>
                      {step}
                    </span>
                  </div>
                  {!isLast && (
                    <div className="flex-1 h-px bg-white/20 mx-3 relative">
                      <div className="absolute inset-0 svg-flow border-t border-dashed border-[#D4AF37]/40" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 mt-10 border-t border-l border-white/15">
          {[t.framework.m, t.framework.a, t.framework.x].map((s) => (
            <div key={s.letter} data-testid={`max-step-${s.letter.toLowerCase()}`} className="border-r border-b border-white/15 p-8">
              <div className="flex items-baseline gap-4">
                <span className="font-display text-5xl font-light text-[#D4AF37]">{s.letter}</span>
                <span className="font-display text-base font-semibold text-white">{s.label}</span>
              </div>
              <p className="mt-4 text-sm text-white/70 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
